import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { navLinks } from '@/mocks/homeData';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="#home" className="flex items-center gap-2">
            <img
              src={
                scrolled
                  ? '/images/logo_b.png'
                  : '/images/logo_w.png'
              }
              alt="대전이혼전문변호사 신가영 법률사무소 로고"
              className="h-8 md:h-10 w-auto"
            />
            <span
              className={`font-heading text-base md:text-lg font-bold transition-colors ${
                scrolled ? 'text-foreground-950' : 'text-background-50'
              }`}
            >
              신가영 법률사무소
            </span>
          </a>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-500'
                    : 'text-background-50/80 hover:text-background-50'
                }`}
              >
                {t(link.label)}
              </a>
            ))}
            <a
              href="https://blog.naver.com/ant1301"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="flex items-center gap-2 bg-primary-500 text-background-50 px-4 py-2 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-global-line text-xs"></i>
              </span>
              네이버 블로그
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center transition-colors ${
              scrolled ? 'text-foreground-950' : 'text-background-50'
            }`}
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
            </span>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="text-base font-medium text-foreground-950 hover:text-primary-500 py-2 transition-colors"
              >
                {t(link.label)}
              </a>
            ))}
            <a
              href="tel:010-2833-1395"
              className="flex items-center justify-center gap-2 bg-primary-500 text-background-50 px-4 py-3 rounded-md text-base font-medium hover:bg-primary-600 transition-colors mt-2"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-xs"></i>
              </span>
              010-2833-1395
            </a>
            <a
              href="https://blog.naver.com/ant1301"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="flex items-center justify-center gap-2 bg-primary-400 text-background-50 px-4 py-3 rounded-md text-base font-medium hover:bg-primary-500 transition-colors"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-global-line text-xs"></i>
              </span>
              네이버 블로그
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}